module.exports = __webpack_public_path__ + "media/images/bus-deef8a651e19cd4c21c2712efe42366a.png";